import * as yup from 'yup';

export const departmentSchema = yup.object({
  name: yup.string().required('Department name is required').min(2, 'Name must be at least 2 characters'),
  code: yup.string().optional().nullable(),
});

export const departmentEditSchema = yup.object({
  name: yup.string().required('Department name is required').min(2, 'Name must be at least 2 characters'),
  code: yup.string().optional().nullable(),
  is_active: yup.boolean(),
});
